



























































































import "./team-setup.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import VueTagsInput from "@johmun/vue-tags-input";
import DefinedColorPicker from "./../common/defined-color-picker.vue";
import UserAvatar from "../common/user-avatar.vue";
let _ = require("lodash");

export default Vue.extend({
  name: "team-setup",
  components: {
    VueTagsInput,
    DefinedColorPicker,
    UserAvatar,
  },
  props: {
    team: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in the Team Name",
            trigger: "blur",
          },
          {
            type: "string",
            max: 40,
            message: "Please limit your Team Name to max 40 characters. Thanks!",
            trigger: "blur",
          },
        ],
        description: [
          {
            type: "string",
            max: 1200,
            message: "Please limit your Team Description to max 1,200 characters. Thanks!",
            trigger: "blur",
          },
        ],
        color: [
          {
            type: "string",
            required: true,
            message: "Please pick the color for the team card.",
            trigger: "blur",
          },
        ],
        completedPercentage: [
          {
            type: "number",
            min: 0,
            max: 100,
            message: "Completed percentage must be between 0 and 100.",
            trigger: "change",
          },
        ],
        hashTagList: [
          {
            type: "array",
            required: true,
            message: "Please fill in the Grouping Tags",
            trigger: "change",
          },
        ],
        members: [
          {
            type: "array",
            required: true,
            message: "Please select a member",
            validator: (rule, value, callback) => {
              if (value && value.filter((member) => member.selected === true).length > 0) {
                callback();
              } else {
                callback(new Error("Error!"));
              }
            },
          },
        ],
      },
      memberRules: {
        role: [
          {
            type: "number",
            required: true,
            message: "Please select a role",
            trigger: "change",
          },
        ],
      },
      activePage: "",
      tag: "",
      tags: [],
      currentTeam: {
        name: null,
        description: "",
        hashTags: "",
        hashTagList: [],
        color: "#0178B5",
        completedPercentage: NaN,
        completed: false,
        members: [],
      },
    };
  },
  watch: {
    showModal(newVal) {
      this.gotoPage("details");

      if (newVal === true) {
        this.currentTeam.name = this.team.name;
        if (!!this.team.color) {
          this.currentTeam.color = this.team.color;
        } else {
          this.currentTeam.color = "#0178B5";
        }
        this.currentTeam.completedPercentage = this.team.completedPercentage;
        this.currentTeam.description = this.team.description;
        this.currentTeam.hashTags = this.team.hashTags;
        this.currentTeam.hashTagList = this.currentTeam.hashTags ? JSON.parse(this.currentTeam.hashTags) : [];
        this.currentTeam.completed = this.team.completed;

        let context = this as any;
        this.currentTeam.members = context.activeUsers.map((user) => {
          let result = Object.assign({}, user);

          let member = _.find(this.team.members, function (member) {
            return user.memberId === member.memberId;
          });

          result.selected = !!member;
          result.role = !!member ? member.role : null;

          return result;
        });
      }
    },
  },
  computed: {
    ...mapGetters("billing", ["activeUsers"]),
    ...mapGetters("team", ["currentTeamInviteRoles"]),
    showModal(): boolean {
      return this.showEditor;
    },
    detailsCompleted(): any {
      let team = this.currentTeam;
      return team.name != null && team.hashTagList.length > 0 && team.color != null;
    },
    membersCompleted(): any {
      return true;
    },
  },
  mounted() {
    (this.$refs.ColorPicker as any).setDropIndexGetter((this.$refs.TeamSetupModal as any).handleGetModalIndex);
  },
  methods: {
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    tagsChanged(newTags) {
      this.currentTeam.hashTagList = newTags;
      (this.$refs.SetupForm as any).validateField("hashTagList");
    },
    checkMember(member) {
      member.selected = !member.selected;
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = this.$refs.SetupForm;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let teamDto = {
            id: this.team.id,
            name: this.currentTeam.name,
            color: this.currentTeam.color,
            completedPercentage: this.currentTeam.completedPercentage,
            description: this.currentTeam.description,
            hashTags: JSON.stringify(this.currentTeam.hashTagList),
            completed: this.currentTeam.completed,
          };

          teamDto[this.team.id ? "updatedMembers" : "members"] = this.currentTeam.members
            .filter((member) => member.selected === true)
            .map((member) => {
              return { memberId: member.memberId, role: member.role, accepted: true };
            });

          let actionName = this.team.id ? "team/update" : "team/create";
          let context = this;
          context.$store.dispatch(actionName, { data: teamDto }).then((response) => {
            context.$emit("cancel");
            target.disabled = false;
          });
        } else {
          let fields = (form as any).fields.filter((field) => field.validateState === "error");
          if (fields != null && fields.length > 0) {
            let page = fields[0].$el.closest(".tab-content-wrap");
            if (page != null) {
              let pageName = page.getAttribute("name");
              this.gotoPage(pageName);
            }
          }

          target.disabled = false;
        }
      });
    },
    handlerWizardStep(forward) {
      let steps = ["details", "members"];
      let nextStepIndex = _.findIndex(steps, (step) => step === this.activePage) + (forward ? 1 : -1);
      this.gotoPage(steps[nextStepIndex]);
    },
    gotoPage(name) {
      this.activePage = name;
    },
    selectHandler(item) {
      this.activePage = item;
    },
  },
});
